import { aboutCards } from "@/mocks/publico";

export default function PublicAboutSection() {
  return (
    <section id="sobre" className="py-14 md:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4">Sobre o Portal</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            O Portal Público FloraIQ apresenta dados ambientais de forma acessível, transparente e georreferenciada, apoiando a participação social, a gestão pública e o planejamento urbano sustentável.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {aboutCards.map((card) => (
            <div
              key={card.title}
              className="bg-background-50 rounded-xl p-5 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center shrink-0">
                  <i className={`${card.icon} text-primary-600 text-lg w-5 h-5 flex items-center justify-center`} />
                </div>
                <h3 className="text-sm font-semibold text-foreground-900">{card.title}</h3>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed">{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}